import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import axios from "axios";

import { __API_URL__ } from "../SERVER_URL";

const sendMessage = async ({
  patient_id,
  notification_title,
  notification_message,
  notification_types,
  notification_time,
  trial_id,
}) => {
  const token = localStorage.getItem("token");

  if (!patient_id) {
    throw new Error("patient_id is required to send notification");
  }

  const payload = {
    patient_id,
    notification_title,
    notification_message,
    notification_types,
    notification_time,
    trial_id,
  };

  const { data } = await axios.post(`${__API_URL__}/api/patient/patient/send_messages/`, payload, {
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "application/json",
    },
  });

  return data;
};

const useSendMessagesMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: sendMessage,
    onSuccess: (data) => {
      const message = data?.message || "Notifications processed successfully.";
      toast.success(message);
      queryClient.removeQueries({ queryKey: ["patient_messages"] });
    },
    onError: (error) => {
      const errMsg =
        error?.response?.data?.message || error?.message || "Failed to send notifications.";
      toast.error(errMsg);
      console.error("Notification send failed:", error);
    },
  });
};

export default useSendMessagesMutation;
